package com.example.readingnotes.domain.model

import kotlinx.datetime.Instant

data class Tag(
    val id: String, // UUID
    val name: String,
    val color: String? = null, // HEX color code for tag visualization
    val createdAt: Instant,
    val updatedAt: Instant,
)

data class PostTag(
    val postId: String, // UUID
    val tagId: String, // UUID
    val createdAt: Instant,
)

data class TagWithCount(
    val tag: Tag,
    val postCount: Int,
)
